export default __webpack_public_path__ + "static/media/feather-command.7383beeb.svg";